import React, { useState, useMemo, useCallback } from "react";
import shortId from 'shortid';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Button,
    ButtonGroup,
    Tooltip,
    Spinner
} from 'reactstrap';

import HelpModal from "../components/HelpModal";

function CustomButton({
   className,
   loading,
   loadingText,
   spinnerProps,
   help,
   helpProps,
   onClick,
   tooltip,
   disabled,
   tag,
   children,
   ...props
}) {
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const mainButtonId = useMemo(() => `tooltip-${shortId.generate()}`, [])
  const toggleTooltip = useCallback(() => setTooltipOpen(open => !open), []);
  const toggleHelpModal = useCallback(() => setIsHelpOpen(open => !open), []);

  const text = loading ? <>
      <Spinner
        type="border" 
        color={spinnerProps?.color ?? "light"}
        role="status"
        style={{borderWidth: "1.5px", width: "1rem", height: "1rem"}}
      />  {loadingText}
    </> : children;
  
  return (
    <>
       { tooltip && disabled && 
          <Tooltip placement="top" isOpen={tooltipOpen} target={mainButtonId} toggle={toggleTooltip}>
            {tooltip}
          </Tooltip> 
        }
      <ButtonGroup className={className}>
          <Button {...props} tag={tag} id={mainButtonId} onClick={onClick} className={clsx(disabled && 'disabled')}>
              {text}
          </Button>
          { help && 
            <Button 
              id="TooltipHelpButton"
              {...props}
              onClick={toggleHelpModal}
            >
                <FontAwesomeIcon icon="question-circle" className="text-muted" />
            </Button>
          }
      </ButtonGroup>
      <HelpModal 
        isOpen={isHelpOpen}
        toggle={toggleHelpModal}
        text={helpProps?.text}
        title={helpProps?.title}
      />
    </>
  )
}

export default CustomButton;